import API from '../../services/LessonRegisterService';
import { registerKey } from '../lessonRegisterReadModel';
import { getStoredAuthEpoch } from '../../services/authTokenStorage';
import { apiCallError, beginApiCall } from './apiStatusActions';
import * as types from './actionTypes';

const MAX_AGE_MS = 60000;
const pendingByStore = new WeakMap();
const identity = state => JSON.stringify([
  state.user && state.user.id,
  state.user && state.user.schoolId,
  state.user && state.user.activeContextKey,
  state.user && state.user.role,
  getStoredAuthEpoch(),
]);
const loadSlice = (query, { force = false } = {}) => (dispatch, getState) => {
  const scope = identity(getState());
  const readKey = JSON.stringify([scope, query]);
  const loadedAt = (getState().lessonRegisterReads || {})[readKey];
  if (!force && loadedAt !== undefined && Date.now() - loadedAt < MAX_AGE_MS) return Promise.resolve();
  if (!pendingByStore.has(getState)) pendingByStore.set(getState, new Map());
  const pending = pendingByStore.get(getState);
  if (pending.has(readKey)) return pending.get(readKey);

  const before = new Map((getState().lessonRegister || []).map(record => [registerKey(record), record]));
  dispatch(beginApiCall('getLessonRegisterSlice'));
  const request = (query.lessonId
    ? API.getLessonRegisterForLesson(query.lessonId)
    : API.getLessonRegisters(query.fromDate, query.toDate))
    .then((lessonRegisters) => {
      if (identity(getState()) !== scope) {
        dispatch({ type: types.LESSON_REGISTER_READ_IGNORED_SUCCESS });
        return;
      }
      const after = new Map((getState().lessonRegister || []).map(record => [registerKey(record), record]));
      // A mutation after this read began wins, including a deletion.
      const recentWrites = (getState().lessonRegisterReads || {}).writes || {};
      const preserveKeys = [...new Set([...before.keys(), ...after.keys(), ...Object.keys(recentWrites)])]
        .filter(key => before.get(key) !== after.get(key) || Date.now() - recentWrites[key] < MAX_AGE_MS);
      dispatch({
        type: types.LOAD_LESSON_REGISTER_SLICE_SUCCESS,
        lessonRegisters,
        query,
        preserveKeys,
        readKey,
        loadedAt: Date.now(),
      });
    })
    .catch((error) => {
      dispatch(apiCallError(error));
      throw error;
    })
    .finally(() => pending.delete(readKey));
  pending.set(readKey, request);
  return request;
};

export const loadLessonRegistersForRange = (fromDate, toDate) => loadSlice({ fromDate, toDate });
export const loadLessonRegisterForLesson = (lessonId, options) => loadSlice({ lessonId }, options);
